import { openModal } from '@core/components/ModalStack';
import { TimeMaterialPaymentModalProps } from './TimeMaterialPaymentModal';

export async function openTimeMaterialPaymentModal(props: TimeMaterialPaymentModalProps) {
  const { TimeMaterialPaymentModal } = await import('./TimeMaterialPaymentModal');

  openModal(TimeMaterialPaymentModal, props);
}
